const STORAGE_KEY = 'aryan-sidebar-collapsed';

/**
 * Read the persisted "Sidebar collapsed" preference.
 * Returns `false` when no preference is set, the value isn't parsable, or window/localStorage is
 * unavailable (SSR-safety nicety even though we're client-only in v1.0).
 */
export function readSidebarCollapsed(): boolean {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return false;
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw === 'true';
  } catch {
    // QuotaExceeded / disabled storage / etc. Fail safe to expanded.
    return false;
  }
}

/** Persist the "Sidebar collapsed" preference. Silent on storage errors. */
export function writeSidebarCollapsed(collapsed: boolean): void {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, collapsed ? 'true' : 'false');
  } catch {
    // Silent: not worth crashing the UI over.
  }
}
